<template>
  <article class="d-flex justify-content-center w-100 h-100 min-vh-100 px-sm-2 px-xxs-0 py-sm-3
    pt-xxs-5 pb-xxs-0 align-items-sm-center">
    <section class="d-flex flex-column col-lg-5 col-sm-7 col-xxs-12 p-sm-5 p-xxs-4 mt-md-5 text-dark bg-white">
      <h1 v-if="colorfulThemeConfig"  class="text-danger mb-5 mt-5 px-md-5 px-sm-3 px-xs-1">
        {{  colorfulThemeConfig.title }}
      </h1>
      <h1 v-else class="text-danger mb-5 mt-5 px-md-5 px-sm-3 px-xs-1">
        {{ $t('Terms.title') }}
      </h1>
      <p v-if="colorfulThemeConfig" class="terms-description px-md-5 px-sm-3 px-xs-1 text-justify"
      v-html="colorfulThemeConfig.text" />
      <p v-else class="terms-description px-md-5 px-sm-3 px-xs-1 text-justify">{{ $t('Terms.text') }}</p>
    </section>
  </article>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
  name: 'TermsAndConditionsIndependent',
  data(){
    return{
      colorfulThemeConfig : null
    }
  },
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config'
    }),
  },
  mounted(){
        this.colorfulThemeConfig = this.designConfig.pages['termsColorfulTheme'].configurations
  }
})
</script>
